export function isCFOPImportacao(cfop) {
  const codigo = cfop && typeof cfop === "object" ? cfop.codigo : cfop;
  return String(codigo).startsWith("3");
}
